export default __webpack_public_path__ + "static/media/how-to-use-3.84b42a91.webp";